import React from 'react';
import { createSvgIcon } from '../helpers/createSvgIcon';
export var SpinnerIcon = createSvgIcon(React.createElement(React.Fragment, null, React.createElement("g", {
  transform: 'rotate(0 50 50)'
}, React.createElement("rect", {
  x: '46.5',
  y: '2',
  rx: '3.5',
  ry: '3.74',
  width: '7',
  height: '22',
  fill: 'currentColor'
}, React.createElement("animate", {
  attributeName: 'opacity',
  values: '1;0',
  keyTimes: '0;1',
  dur: '0.7407407407407407s',
  begin: '-0.6790123456790123s',
  repeatCount: 'indefinite'
}))), React.createElement("g", {
  transform: 'rotate(30 50 50)'
}, React.createElement("rect", {
  x: '46.5',
  y: '2',
  rx: '3.5',
  ry: '3.74',
  width: '7',
  height: '22',
  fill: 'currentColor'
}, React.createElement("animate", {
  attributeName: 'opacity',
  values: '1;0',
  keyTimes: '0;1',
  dur: '0.7407407407407407s',
  begin: '-0.6172839506172838s',
  repeatCount: 'indefinite'
}))), React.createElement("g", {
  transform: 'rotate(60 50 50)'
}, React.createElement("rect", {
  x: '46.5',
  y: '2',
  rx: '3.5',
  ry: '3.74',
  width: '7',
  height: '22',
  fill: 'currentColor'
}, React.createElement("animate", {
  attributeName: 'opacity',
  values: '1;0',
  keyTimes: '0;1',
  dur: '0.7407407407407407s',
  begin: '-0.5555555555555555s',
  repeatCount: 'indefinite'
}))), React.createElement("g", {
  transform: 'rotate(90 50 50)'
}, React.createElement("rect", {
  x: '46.5',
  y: '2',
  rx: '3.5',
  ry: '3.74',
  width: '7',
  height: '22',
  fill: 'currentColor'
}, React.createElement("animate", {
  attributeName: 'opacity',
  values: '1;0',
  keyTimes: '0;1',
  dur: '0.7407407407407407s',
  begin: '-0.4938271604938271s',
  repeatCount: 'indefinite'
}))), React.createElement("g", {
  transform: 'rotate(120 50 50)'
}, React.createElement("rect", {
  x: '46.5',
  y: '2',
  rx: '3.5',
  ry: '3.74',
  width: '7',
  height: '22',
  fill: 'currentColor'
}, React.createElement("animate", {
  attributeName: 'opacity',
  values: '1;0',
  keyTimes: '0;1',
  dur: '0.7407407407407407s',
  begin: '-0.4320987654320987s',
  repeatCount: 'indefinite'
}))), React.createElement("g", {
  transform: 'rotate(150 50 50)'
}, React.createElement("rect", {
  x: '46.5',
  y: '2',
  rx: '3.5',
  ry: '3.74',
  width: '7',
  height: '22',
  fill: 'currentColor'
}, React.createElement("animate", {
  attributeName: 'opacity',
  values: '1;0',
  keyTimes: '0;1',
  dur: '0.7407407407407407s',
  begin: '-0.3703703703703703s',
  repeatCount: 'indefinite'
}))), React.createElement("g", {
  transform: 'rotate(180 50 50)'
}, React.createElement("rect", {
  x: '46.5',
  y: '2',
  rx: '3.5',
  ry: '3.74',
  width: '7',
  height: '22',
  fill: 'currentColor'
}, React.createElement("animate", {
  attributeName: 'opacity',
  values: '1;0',
  keyTimes: '0;1',
  dur: '0.7407407407407407s',
  begin: '-0.3086419753086419s',
  repeatCount: 'indefinite'
}))), React.createElement("g", {
  transform: 'rotate(210 50 50)'
}, React.createElement("rect", {
  x: '46.5',
  y: '2',
  rx: '3.5',
  ry: '3.74',
  width: '7',
  height: '22',
  fill: 'currentColor'
}, React.createElement("animate", {
  attributeName: 'opacity',
  values: '1;0',
  keyTimes: '0;1',
  dur: '0.7407407407407407s',
  begin: '-0.24691358024691354s',
  repeatCount: 'indefinite'
}))), React.createElement("g", {
  transform: 'rotate(240 50 50)'
}, React.createElement("rect", {
  x: '46.5',
  y: '2',
  rx: '3.5',
  ry: '3.74',
  width: '7',
  height: '22',
  fill: 'currentColor'
}, React.createElement("animate", {
  attributeName: 'opacity',
  values: '1;0',
  keyTimes: '0;1',
  dur: '0.7407407407407407s',
  begin: '-0.18518518518518515s',
  repeatCount: 'indefinite'
}))), React.createElement("g", {
  transform: 'rotate(270 50 50)'
}, React.createElement("rect", {
  x: '46.5',
  y: '2',
  rx: '3.5',
  ry: '3.74',
  width: '7',
  height: '22',
  fill: 'currentColor'
}, React.createElement("animate", {
  attributeName: 'opacity',
  values: '1;0',
  keyTimes: '0;1',
  dur: '0.7407407407407407s',
  begin: '-0.12345679012345677s',
  repeatCount: 'indefinite'
}))), React.createElement("g", {
  transform: 'rotate(300 50 50)'
}, React.createElement("rect", {
  x: '46.5',
  y: '2',
  rx: '3.5',
  ry: '3.74',
  width: '7',
  height: '22',
  fill: 'currentColor'
}, React.createElement("animate", {
  attributeName: 'opacity',
  values: '1;0',
  keyTimes: '0;1',
  dur: '0.7407407407407407s',
  begin: '-0.061728395061728385s',
  repeatCount: 'indefinite'
}))), React.createElement("g", {
  transform: 'rotate(330 50 50)'
}, React.createElement("rect", {
  x: '46.5',
  y: '2',
  rx: '3.5',
  ry: '3.74',
  width: '7',
  height: '22',
  fill: 'currentColor'
}, React.createElement("animate", {
  attributeName: 'opacity',
  values: '1;0',
  keyTimes: '0;1',
  dur: '0.7407407407407407s',
  begin: '0s',
  repeatCount: 'indefinite'
})))), 'Spinner');